import React, { useEffect, useState } from "react";
import { useAuth } from "../Context/AuthContext";
import "../Styling/LeaveDetailsScreen.css";
import { getLeavesData,changeLeaveStatus } from "../Api/leaveDetailsApi";

import { FiUsers, FiSearch } from "react-icons/fi";
import { User, IdCard, Building2 } from "lucide-react";

const LeaveDetailsScreen = () => {
  const { user } = useAuth();

  const [leaveData, setLeaveData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchLeaveData = async () => {
    try {
      const res = await getLeavesData(
        user?.userId,
        user?.organisationId,
        user?.token
      );

      const data = res?.data || [];
      setLeaveData(data);
    } catch (err) {
      console.error("Error fetching leave data:", err);
    }
  };

  useEffect(() => {
    if (user?.userId && user?.organisationId) {
      fetchLeaveData();
    }
  }, [user]);

  const filteredData = leaveData.filter((item) =>
    item?.Resource_name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

const handleLeaveAction = async (item, activity) => {
  try {
    await changeLeaveStatus(
      item?.LeaveMasterNewGUID,
      activity,
      user?.userId
    );

    fetchLeaveData();

    alert(`Leave ${activity} successful`);
  } catch (err) {
    console.error(`${activity} failed`, err);

    alert(`Failed to ${activity} leave`);
  }
};

  return (
    <div className="resource-dashboard-container">

      {/* Header */}
      <div className="resource-dashboard-header">
        <h2>Leave Details</h2>
      </div>

      {/* Summary Label */}
      <div
        style={{
          padding: "14px 24px 0 24px",
          fontSize: "10px",
          fontWeight: 700,
          color: "#9ca3af",
          textTransform: "uppercase",
          letterSpacing: "0.07em",
          background: "#ffffff",
        }}
      >
        Leave Summary
      </div>

      {/* Summary Cards */}
      <div className="resource-dashboard-summary">

        <div className="resource-card highlight">
          <div className="card-row">
            <FiUsers className="card-icon blue" />
            <div className="card-text">
              <p>Total Leaves</p>
              <h3>{leaveData.length}</h3>
            </div>
          </div>
        </div>

        <div className="resource-card accent">
          <div className="card-row">
            <User className="card-icon orange" />
            <div className="card-text">
              <p>Pending Leaves</p>
              <h3>
                {
                  leaveData.filter(
                    (x) =>
                      x?.leaveStatus?.toLowerCase() === "pending"
                  ).length
                }
              </h3>
            </div>
          </div>
        </div>

        <div className="resource-card">
          <div className="card-row">
            <IdCard className="card-icon purple" />
            <div className="card-text">
              <p>Approved Leaves</p>
              <h3>
                {
                  leaveData.filter(
                    (x) =>
                      x?.leaveStatus?.toLowerCase() === "approved"
                  ).length
                }
              </h3>
            </div>
          </div>
        </div>

        <div className="resource-card">
          <div className="card-row">
            <Building2 className="card-icon gray" />
            <div className="card-text">
              <p>Organisation ID</p>
              <h3>{user?.organisationId || "N/A"}</h3>
            </div>
          </div>
        </div>

      </div>

      {/* Search */}
      <div className="resource-search-bar">
        <div className="search-input-wrapper">
          <FiSearch className="search-icon" />

          <input
            type="text"
            placeholder="Search employee..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {searchTerm && (
          <button onClick={() => setSearchTerm("")}>
            Clear
          </button>
        )}
      </div>

      {/* Table */}
      <div className="resource-dashboard-table-wrapper">
        <table className="resource-dashboard-table">

          <thead>
            <tr>
              <th>Employee Name</th>
              <th>Resource ID</th>
              <th>MAV User ID</th>
              <th>Organisation</th>
              <th>Company</th>
              <th>Leave Type</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Duration</th>
              <th>Start Half</th>
              <th>End Half</th>
              <th>Remarks</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>

            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr key={index}>

                  <td className="name-cell">
                    <div className="name-content">
                      <span>{item?.Resource_name}</span>
                      <small>{item?.Description}</small>
                    </div>
                  </td>

                  <td>
                    <span className="resource-id-chip">
                      {item?.ResourceId}
                    </span>
                  </td>

                  <td>{item?.Mav_UserID}</td>

                  <td>{item?.Organisation_Name}</td>

                  <td>{item?.Company_Name}</td>

                  <td>{item?.Description}</td>

                  <td>
                    {item?.leaveStartDate
                      ? new Date(
                          item.leaveStartDate
                        ).toLocaleDateString()
                      : "-"}
                  </td>

                  <td>
                    {item?.leaveEndDate
                      ? new Date(
                          item.leaveEndDate
                        ).toLocaleDateString()
                      : "-"}
                  </td>

                  <td>{item?.leaveDuration}</td>

                  <td>{item?.startHalf}</td>

                  <td>{item?.endHalf}</td>

                  <td>{item?.leaveRemarks}</td>

                  <td>
                    <span
                      className={`status-badge ${
                        item?.leaveStatus?.toLowerCase() ===
                        "pending"
                          ? "status-overdue"
                          : "status-paid"
                      }`}
                    >
                      {item?.leaveStatus || "N/A"}
                    </span>
                  </td>

                      <td>
  {item?.leaveStatus?.toLowerCase() === "pending" ? (
    <div className="leaveDetailsScreen-actionButtons">

      <button
        className="leaveDetailsScreen-approveBtn"
        onClick={() =>
          handleLeaveAction(item, "Approve")
        }
      >
        Approve
      </button>

      <button
        className="leaveDetailsScreen-holdBtn"
        onClick={() =>
          handleLeaveAction(item, "Hold")
        }
      >
        Hold
      </button>

      <button
        className="leaveDetailsScreen-cancelBtn"
        onClick={() =>
          handleLeaveAction(item, "Reject")
        }
      >
        Cancel
      </button>

    </div>
  ) : (
    "-"
  )}
</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="14" className="no-data">
                  No Leave Data Found
                </td>
              </tr>
            )}

          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeaveDetailsScreen;